module.exports = __webpack_public_path__ + "static/media/font_medium.5e5c730d.woff2";